import "./Sidebar.scss"
import LinkWithIcon from "components/common/linkWithIcon/LinkWithIcon"
import { NavigationItemList } from "@/constants/NavigationItemList"
import { useLocation } from "react-router-dom"
import { isPathCurrentRoute } from "@/helpers/navigation"
import clsx from "clsx"
import { useContext, useMemo } from "react"
import { SidebarResponsiveContext, SidebarResponsiveContextValueType } from "@/context/SidebarResponsiveContext"
import { CloseRounded } from "@mui/icons-material"
import { IconType, NotificationConfig } from "components/common/labelWithIcon/LabelWithIcon"
import { useAppSelector } from "@/hooks/reduxToolkitHook"
import { WalletTransaction } from "@/types/TransactionsType"

export interface NavigationItem {
  label: string;
  link: string;
  Icon: IconType;
  notification?: NotificationConfig;
}

type SidebarProps = {}

const Sidebar = (props: SidebarProps) => {
  const location = useLocation()
  const { isExpanded, expand } = useContext(
    SidebarResponsiveContext,
  ) as SidebarResponsiveContextValueType
  // Get transactions from Redux
  const { transactions } = useAppSelector(
    (state) => state.transactions,
  )


  const pendingTransactionsCount = useMemo(() => {
    return transactions.filter(
      (tx: WalletTransaction) => tx.needs_validation,
    ).length
  }, [transactions])

  // Build navigation items with dynamic notifications
  const navigationItems = useMemo<NavigationItem[]>(() => {
    return NavigationItemList.map((item) => {
      // Add notification for Transactions menu
      if (item.link === "/transactions" && pendingTransactionsCount > 0) {
        return {
          ...item,
          notification: {
            type: "danger" as const,
            count: pendingTransactionsCount,
            pulse: false,
          },
        }
      }
      return item
    })
  }, [pendingTransactionsCount])

  // console.log(navigationItems)

  const DrawerWithLink = () => (
    <>
      <div className="flex items-center justify-between py-8 mb-4 border-b">
        <div className="m-auto flex flex-col items-start justify-between">
          <h1 className="font-semibold text-base lg:text-xl text-blue-500">
            Uptimise | Gestionnaire
          </h1>
          <p className="text-base text-xs text-gray-500 "> Gestion wallet & Abonnements</p>
        </div>
        <CloseRounded
          color="primary"
          onClick={expand}
          className="lg:hidden"
        />
      </div>
      {navigationItems.map((menuItem, index) => {
        const isActive = isPathCurrentRoute(location, menuItem.link)
        return (
          <div
            key={index}
            className={clsx(
              "pl-4 py-2 mx-4 mr-7 rounded-md",
              isActive
                ? "bg-blue-200 menu-border-isActive pl-3 pr-3 font-medium"
                : "",
            )}>
            <LinkWithIcon
              linkProps={{
                to: menuItem.link,
              }}
              label={menuItem.label}
              Icon={menuItem.Icon}
              notification={menuItem.notification}
              style={{
                mainStyle: isActive ? "up-sidebar-link-active" : "",
                labelStyle: " text-ellipsis",
              }}
            />
          </div>
        )
      })}
      {/*<div*/}
      {/*  onClick={() => keycloak.logout()}*/}
      {/*  className="cursor-pointer pl-6 py-3 text-gray-500 flex items-center">*/}
      {/*  <LogoutRounded />*/}
      {/*  <p className="ml-2 text-lg font-normal leading-[0px]">Se déconnecter</p>*/}
      {/*</div>*/}
    </>
  )

  return (
    <>
      {isExpanded && (
        <div className="lg:hidden fixed bg-white w-[60%] h-full z-50 m-0 top-0 py-4 overflow-auto">
          <DrawerWithLink />
        </div>
      )}
      <div className="hidden lg:block sticky top-0 bg-white h-full m-0 overflow-auto">
        <DrawerWithLink />
      </div>
    </>
  )
}
export default Sidebar
